import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=561b1406"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
import style0 from "./modal.vue?vue&type=style&index=0&id=561b1406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports